export const API_PATH = {
  AUTH: {
    LOGIN: "auth/admin/login",
  },
  ADMIN: {
    GET_VERIFIED_SALONS: "admin/get-verified-business",
    GET_SALONS_REQUEST: "admin/get-business-request",
    GET_USERS: "admin/get-all-users",
    GET_ADMIN_PROFILE: "admin/my-profile",
    VERIFY_SALON: "admin/verify-business-document",
    REJECT_SALON: "admin/reject-business-document",
    GET_SALON_DETAILS: "admin/get-business-details",
    GET_USER_DETAILS: "admin/get-user-details",
    GET_BUSINESS_STAFF: "admin/get-business-staff",
    GET_BUSINESS_SERVICES: "admin/get-business-services",
    GET_BUSINESS_BOOKINGS: "admin/get-business-bookings",
    GET_USER_BOOKINGS: "admin/get-user-bookings",
    GET_ALL_BOOKINGS: "admin/get-all-bookings",
    GET_BOOKING_DETAILS: "admin/get-booking",
    BlOCK_UNBLOCK_USER: "admin/toggle-block-user",
    BLOCK_UNBLOCK_SALON: "admin/toggle-block-business",
    GET_SERVICES: "common/get-service-admin",
    GET_CATEGORY: "common/get-category-admin",
    DELETE_SERVICE: "common/delete-services",
    ADD_SERVICE: "common/add-services",
    UPDATE_SERVICE: "common/update-services",
    ADD_CATEGORY: "common/add-category",
    UPDATE_CATEGORY: "common/update-category",
    GET_REPORTS: "report/get-reports",
    DELETE_REPORT: "report/delete-report",
    REPORT_DETAILS: "report/get-report-details",
    GET_SERVICES_BY_CATEGORY: "common/services-by-category",
    GET_TICKETS: "ticket/get-all-tickets",
    GET_COMPLAINTS: "complaint/get-all-complaint",
    GET_QUERIES: "query/get-all-queries",
    DELETE_TICKET: "ticket/delete-ticket",
    DELETE_COMPLAINT: "complaint/delete-complaint",
    DELETE_QUERY: "query/delete-query",
    REVERT_REPORTS: "report/revert-report",
    REVERT_COMPLAINTS: "complaint/revert-complaint",
    REVERT_QUERIES: "query/revert-query",
    GET_FAQ: "faq/get-faq-admin",
    GET_WEEKLY_OFFERS: "common/get-offer-admin",
    DELETE_FAQ: "faq/delete-faq",
    UPDATE_FAQ: "faq/update-faq",
    ADD_FAQ: "faq/add-faq",
    ADD_WEEKLY_OFFER: "common/add-weekly-offer",
    UPDATE_WEEKLY_OFFER: "common/update-weekly-offer",
    DELETE_WEEKLY_OFFER: "common/delete-weekly-offer",
    GET_COUPON_CODE: "admin/get-all-coupon",
    GET_ALL_COUPONS: "admin/coupons-list",
    DELETE_COUPON: "admin/delete-coupon",
    ADD_COUPON: "admin/add-coupons",
    UPDATE_COUPON: "admin/update-coupon",
    UPDATE_COUPON_STATUS: "admin/update-coupon-status",
    GET_CONFIG: "config/get-config",
    DELETE_CONFIG: "config/delete-config",
    ADD_CONFIG: "config/add-config",
    UPDATE_CONFIG: "config/update-config",
    UPDATE_CONFIG_STATUS: "config/update-config-status",
    USER_STATS: "admin/user-stats",
    ADMIN_STATS: "admin/stats",
    GRAPH_DATA: "admin/earnings-dashboard",
    GET_PAYMENTS: "admin/payments",
    UPDATE_OFFER_STATUS: "common/publish-weekly-offer",
    UPDATE_PROFILE: "admin/update-profile",
    CHANGE_PASSWORD: "admin/change-password",
    GET_CONTACT_INFO: "common/contact-info",
    ADD_CONTACT_INFO: "common/add-contact-info",
    UPDATE_CONTACT_INFO: "common/update-contact-info",
    DELETE_CONTACT_INFO: "common/delete-contact-info",
    GET_BUSINESS: "admin/get-all-business",
    GET_USERS_BOOKING: "admin/get-users",
    DUMMY_BOOKING: "booking/create-dummy-booking"
  },
};
